<template>
  <div class="max-w-7xl mx-auto px-6 lg:px-8 py-8">
    <BreadCrumbs v-bind:bcrumbs="bcrumbs" />

    <PageTitle v-bind:title="title" v-bind:admin="true" />

    <button
      @click.prevent="showAddForm"
      type="button"
      class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 mt-4 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:w-auto sm:text-sm"
    >
      Новый вопрос
    </button>
    <div
      v-if="showModal"
      class="fixed z-10 inset-0 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <!--
      Background overlay, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true"
        ></div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >

        <!--
      Modal panel, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->
        <div
          class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6"
        >
          <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
            <button
              @click.prevent="cancelAdding"
              type="button"
              class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              <span class="sr-only">Close</span>
              <!-- Heroicon name: outline/x -->
              <svg
                class="h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div class="sm:flex sm:items-start">
            <div
              class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10"
            >
              <svg
                class="h-6 w-6 text-green-600"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            </div>
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
              <h3
                class="text-lg leading-6 font-medium text-gray-900"
                id="modal-title"
              >
                Новый вопрос
              </h3>
              <ErrorMessage
                v-if="errors.add"
                :error="errors.add"
                class="mt-2"
              />
              <div class="mt-2">
                <div>
                  <label
                    for="email"
                    class="block text-sm font-medium text-gray-700"
                    >Вопрос</label
                  >
                  <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                      v-model="name"
                      type="text"
                      name="name"
                      id="name"
                      :class="[
                        'block w-full pr-10  focus:outline-none  sm:text-sm rounded-md',
                        errors.validationAdd && errors.validationAdd.name
                          ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
                          : '',
                      ]"
                    />
                    <div
                      v-if="errors.validationAdd && errors.validationAdd.name"
                      class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                    >
                      <svg
                        class="h-5 w-5 text-red-500"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                  </div>
                  <p
                    v-if="errors.validationAdd && errors.validationAdd.name"
                    class="mt-2 text-sm text-red-600"
                  >
                    {{ errors.validationAdd.name[0] }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <button
              @click.prevent="addRecord"
              type="button"
              class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm"
            >
              Сохранить
            </button>
            <button
              @click.prevent="cancelAdding"
              type="button"
              class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
            >
              Отмена
            </button>
          </div>
        </div>
      </div>
    </div>


    <!-- Модальное окно для подтверждения удаления -->
    <ModalOkCancel v-bind:data="ModalOkCancelData" v-on:mrok="deleteRecord2" />

    <ErrorMessage v-if="errors.load" :error="errors.load" />

    <Loader v-if="loading" />
    <div v-else-if="data.length">
      <ErrorMessage v-if="errors.delete" :error="errors.delete" />

      <div class="my-8 flex flex-col">
        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div
            class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8"
          >
            <div
              class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
            >
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    ></th>

                    <th
                      scope="col"
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      <div>
                        <label
                          for="name"
                          class="block text-sm font-medium text-gray-700"
                          >Название</label
                        >
                        <div class="mt-1">
                          <input
                            v-model="f_name"
                            type="text"
                            name="name"
                            id="name"
                            class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          />
                        </div>
                      </div>
                    </th>
                    <th scope="col" class="relative px-6 py-3">
                      <span class="block text-sm font-medium text-gray-700">
                        Сортировка
                      </span>
                    </th>
                    <th scope="col" class="relative px-6 py-3">
                      <span class="sr-only">Menu</span>
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <tr v-for="item in filteredData" :key="item.id">
                    <td
                      class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-500"
                    >
                      {{ item.id }}
                    </td>
                    <td class="px-6 py-4 text-sm text-gray-900">
                      <router-link
                        :to="{
                          name: 'adminQuestion_show',
                          params: { id: item.id },
                        }"
                        >{{ item.name }}</router-link
                      >
                    </td>
                    <td
                      class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                    >
                      {{ item.orderby }}
                    </td>

                    <td
                      class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium"
                    >
                      <!-- relative -->
                      <div class="hover:inline-block text-left">
                        <div>
                          <button
                            @click="toggleDropdown(item.id)"
                            type="button"
                            class="bg-gray-100 rounded-full flex items-center text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500"
                            :id="'options-menu-' + item.id"
                            aria-expanded="true"
                            aria-haspopup="true"
                          >
                            <span class="sr-only">Open options</span>
                            <!-- Heroicon name: solid/dots-vertical -->
                            <svg
                              class="h-5 w-5"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              aria-hidden="true"
                            >
                              <path
                                d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
                              />
                            </svg>
                          </button>
                        </div>

                        <!--
                          Dropdown menu, show/hide based on menu state.

                          Entering: "transition ease-out duration-100"
                            From: "transform opacity-0 scale-95"
                            To: "transform opacity-100 scale-100"
                          Leaving: "transition ease-in duration-75"
                            From: "transform opacity-100 scale-100"
                            To: "transform opacity-0 scale-95"
                        -->
                        <div
                          v-if="item.id == dropdownToggled"
                          class="divide-y divide-gray-200 z-40 origin-top-right absolute right-16 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="options-menu"
                        >
                          <div>
                            <div class="py-1" role="none">
                              <router-link
                                :to="{
                                  name: 'adminQuestion_edit',
                                  params: { id: item.id },
                                }"
                                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                                >Редактировать вопрос</router-link
                              >
                            </div>
                          </div>

                          <div>
                            <div class="py-1" role="none">
                              <router-link
                                :to="{
                                  name: 'adminQuestion_answers',
                                  params: { question_id: item.id },
                                }"
                                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                                >Список ответов</router-link
                              >
                            </div>
                          </div>
                          <div>
                            <div class="py-1" role="none">
                              <button
                                @click.prevent="askToDeleteRecord(item)"
                                type="button"
                                class="block w-full text-left px-4 py-2 text-sm text-red-700 hover:bg-red-100 hover:text-red-900"
                              >
                                УДАЛИТЬ
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loader from "@/components/Loader";
// import jQuery from "jquery";
import BreadCrumbs from "@/components/BreadCrumbs";
import PageTitle from "@/components/PageTitle";
import ModalOkCancel from "@/components/ModalOkCancel";
import ErrorMessage from "../components/ErrorMessage.vue";

export default {
  data() {
    return {
      loading: true,
      data: [],
      id: 0,
      name: "",
      errors: {
        load: "",
        add: "",
        delete: "",
        edit: "",
        validationAdd: {},
        validationEdit: {},
      },
      ModalOkCancelData: {
        id: 0,
        caption: "",
        message: "",
        show: false,
        style: "",
        okCaption: "Удалить!",
      },
      title: "Список вопросов",
      bcrumbs: [],

      // для фильтрации:
      f_name: "",

      showModal: false,
      dropdownToggled: false,
    };
  },

  computed: {
    filteredData() {
      return this.data.filter((rec) =>
        rec.name.toLowerCase().includes(this.f_name.toLowerCase())
      );
    },
  },
  async mounted() {
    this.loadRecords(this.$route.params.chapter_id);
  },
  methods: {
    toggleDropdown(id) {
      if (this.dropdownToggled) {
        this.dropdownToggled = false;
      } else {
        this.dropdownToggled = id;
      }
    },
    clearErrors() {
      this.errors.load = "";
      this.errors.add = "";
      this.errors.delete = "";
      this.errors.edit = "";
    },

    async loadRecords(chapter_id) {
      this.errors.load = "";
      try {
        this.loading = true;
        let response = await axios.get(
          "admin/chapters/" + chapter_id + "/exams"
        );
        this.data = response.data.exams;
        this.bcrumbs = response.data.bcrumbs;
        this.loading = false;
      } catch (e) {
        this.errors.load = "Ошибка при загрузке данных";
      }
    },
    showAddForm() {
      this.name = "";
      this.errors.validationAdd = {};
      this.clearErrors();
      this.showModal = true;
    },
    cancelAdding() {
      this.name = "";
      this.showModal = false;
    },
    //
    // Add new record.
    //
    async addRecord() {
      var chapter_id = this.$route.params.chapter_id;
      this.errors.validationAdd = {};
      this.clearErrors();
      try {
        let response = await axios.post(
          "admin/chapters/" + chapter_id + "/exams",
          { name: this.name }
        );
        if (response.status == 200) {
          this.name = "";
          this.loadRecords(chapter_id);
          this.showModal = false;
        }
      } catch (e) {
        if (e.response.status == 422) {
          this.errors.validationAdd = e.response.data.errors;
        } else if (e.response.status == 520) {
          this.errors.add = e.response.data.error;
        } else {
          this.errors.add = "Неизвестная ошибка при создании записи.";
        }
      }
    },

    //
    // Показываем MessageBox с подтверждением удаления Вопроса.
    //
    askToDeleteRecord(item) {
      this.clearErrors();
      this.ModalOkCancelData.id = item.id;
      this.ModalOkCancelData.style = "danger";
      this.ModalOkCancelData.caption = "Внимание!";
      this.ModalOkCancelData.message =
        'Вы действительно хотите удалить Вопрос <strong>"' +
        item.name +
        '"</strong>?';
      this.ModalOkCancelData.show = true;
    },

    //
    // Удаление вопроса.
    //
    async deleteRecord2() {
      this.clearErrors();
      var id = arguments[0];
      if (id > 0) {
        try {
          let response = await axios.delete("admin/exams/" + id);
          if (response.status == 200) {
            // удаление эл-та из списка "на клиенте":
            let index = this.data.findIndex((tmpdata) => tmpdata.id == id);
            this.data.splice(index, 1);
          }
        } catch (e) {
          if (e.response.status == 520) {
            this.errors.delete = e.response.data.error;
          } else {
            this.errors.delete = "Неизвестная ошибка при удалении.";
          }
        }
      }
    },


  },
  components: {
    Loader,
    BreadCrumbs,
    PageTitle,
    ModalOkCancel,
    ErrorMessage,
  },
};
</script>